import React from "react";
import { Card, CardContent } from "@shadcn-in-nx/ui/card";
import { Badge } from "@shadcn-in-nx/ui/badge";
import { Button } from "@shadcn-in-nx/ui/button";
import { CheckCircle, Circle, MessageSquare } from "lucide-react";
import { useNavigate } from "react-router-dom";

const CATEGORY_COLORS = {
    harness: "bg-red-100 text-red-800",
    frustration: "bg-orange-100 text-orange-800",
    feature: "bg-blue-100 text-blue-800",
    general: "bg-gray-100 text-gray-800",
    ux: "bg-purple-100 text-purple-800",
    reliability: "bg-yellow-100 text-yellow-800",
    performance: "bg-cyan-100 text-cyan-800",
    accuracy: "bg-pink-100 text-pink-800",
    error_handling: "bg-amber-100 text-amber-800",
};

export default function ReportRow({ report, onSelect, onResolve, selected }) {
    const navigate = useNavigate();
    const colorClass = CATEGORY_COLORS[report.category] || CATEGORY_COLORS.general;

    return (
        <Card className={`cursor-pointer transition-colors hover:bg-muted/50 ${selected ? "ring-2 ring-primary" : ""}`} onClick={() => onSelect(report)}>
            <CardContent className="py-3 px-4 flex items-center gap-4">
                <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 mb-1">
                        <Badge variant="outline" className={colorClass}>{report.category || "unknown"}</Badge>
                        <Badge variant="outline">{report.type}</Badge>
                        <span className="text-xs text-muted-foreground">{report.companyName}</span>
                        <span className="text-xs text-muted-foreground ml-auto">
                            {new Date(report.createdAt).toLocaleDateString()}
                        </span>
                    </div>
                    <p className="text-sm truncate">{report.objective}</p>
                </div>
                <div className="flex items-center gap-2 shrink-0">
                    {report.stepChatId && (
                        <Button variant="ghost" size="sm" onClick={(e) => { e.stopPropagation(); navigate(`/admin/chats/${report.stepChatId}`); }}>
                            <MessageSquare className="h-4 w-4" />
                        </Button>
                    )}
                    <Button variant="ghost" size="sm" onClick={(e) => { e.stopPropagation(); onResolve(report.id, !report.resolved); }}>
                        {report.resolved ? <CheckCircle className="h-4 w-4 text-green-500" /> : <Circle className="h-4 w-4 text-muted-foreground" />}
                    </Button>
                </div>
            </CardContent>
        </Card>
    );
}
